import axios from "axios";
import authHeader from "./auth-header";
import IUser from "../types/user.type";
import {Department} from "../types/enumeration/Department";
import ISetPassword from "../types/set-password.type";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/user`;

export const getById = (id: string) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const getProfileByUserId = (id: string) => {
  return axios.get(API_URL + "/" + id + "/profile", { headers: authHeader() });
};

export const create = (user: IUser) => {
  return axios.post(API_URL, user, { headers: authHeader() });
};

export const update = (id: number, user: IUser) => {
  return axios.put(API_URL + "/" + id, user, { headers: authHeader() });
};

export const getUsers = (params: {}) => {
  return axios.get(API_URL, { params: params, headers: authHeader() });
};

export const getAllActiveByDepartment = (department: Department | null) => {
  return axios.get(API_URL + "/active-by-department", {params: {department: department}, headers: authHeader() });
};

export const setPassword = (id: any, password: ISetPassword) => {
  return axios.put(API_URL + "/" + id + "/set-password", password, { headers: authHeader() });
}
